import { render, staticRenderFns } from "./TypeUrl.vue?vue&type=template&id=6ec23ca2"
import script from "./TypeUrl.vue?vue&type=script&lang=js"
export * from "./TypeUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports